module.exports = __webpack_public_path__ + "static/img/icon_yuyue.1664dd88.png";